import { graphql, type ResultOf } from '@newfront-insurance/graphql-frontend';

export const SKILL_GROUP_PEOPLE_FIELDS = graphql(`
  fragment SkillGroupPeopleFields on SkillGroup @_unmask {
    uuid
    parentGroupUuid
    admins
    managers
    members
    inheritedRoles
    adminEmployees {
      userUuid
      fullName
      email
      imageUrl
    }
    managerEmployees {
      userUuid
      fullName
      email
      imageUrl
    }
    memberEmployees {
      userUuid
      fullName
      email
      imageUrl
    }
  }
`);

export const GET_SKILL_GROUP_PEOPLE = graphql(
  `
    query GetSkillGroupPeople($groupId: String!) {
      getSkillGroup(groupId: $groupId) {
        ...SkillGroupPeopleFields
      }
    }
  `,
  [SKILL_GROUP_PEOPLE_FIELDS],
);

export const TRANSITION_SKILL_GROUP_USER_ROLE = graphql(
  `
    mutation TransitionSkillGroupUserRole($groupId: String!, $userUuid: String!, $role: SkillGroupTransitionRole!) {
      transitionSkillGroupUserRole(groupId: $groupId, userUuid: $userUuid, role: $role) {
        ...SkillGroupPeopleFields
      }
    }
  `,
  [SKILL_GROUP_PEOPLE_FIELDS],
);

export type SkillGroupPeople = ResultOf<typeof GET_SKILL_GROUP_PEOPLE>['getSkillGroup'];
